<template>
    <Table
      :columns="cols"
      :data="tableData"
      :loading="loading"
      border
      :width="cols.reduce((a,v)=>a+v.width,0)+5"
      >
      <BaseLoading v-if="loading" />
      <div class="flex-wrap flex-right" style="font-size:12px;color:var(--subtext3)">

                  </div>
    </Table>
  </template>

<script>

import tableRender from '../../base/tableRender';
export default {
  name: 'CmTableYearContractNewSignType',
  data() {
    return {
      tableData: [{
        dep: '公司',
      }, {
        dep: '建设管理事业部',
      }, {
        dep: '房建监理事业部',
      }, {
        dep: '市政监理事业部',
      }],
      loading: true,
    };
  },
  computed: {
    cols() {
      return [{
        key: 'dep',
        title: '部门',
        align: 'center',
        width: 200,
      }, {
        key: 'current',
        title: '当前新中标',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.current),
      }, {
        key: 'c1',
        title: '全资',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.c1),
      }, {
        key: 'c2',
        title: '项目管理',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.c2),
      }, {
        key: 'c3',
        title: '房建监理',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.c3),
      }, {
        key: 'c4',
        title: '市政监理',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.c4),
      }, {
        key: 'c5',
        title: '其他',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.c5),
      }];
    },
  },
  mounted() {
    this.getData();
  },
  props: {
    year: {
      type: String | Number,
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get(`cm/tables/contract-newsign-type?year=${this.year}`).then((res)=>{
        const result = res.data.data;
        this.tableData = result.data;
        this.created_at = result.created_at;
      }).finally(()=>{
        this.loading = false;
      });
    },
    exportExcel() {

    },
  },
};
</script>

  <style>

  </style>
